import React, { useContext, useEffect } from 'react'
import { LocationContext } from '../../../context/LocationContext'
import { Form } from 'react-bootstrap';

const BlockFilter = ({ className = " ", required, setCurrentPage, disabled = false }) => {
    const { blockList, fetchBlocks, selectedDistrictId, selectedBlockId, setSelectedBlockId } = useContext(LocationContext);
    const handleChange = (e) => {
        setSelectedBlockId(e.target.value);
        if (setCurrentPage) {   // 👈 only call if passed
            setCurrentPage(1);
        }
    };
    useEffect(() => {
        fetchBlocks(selectedDistrictId)
        setSelectedBlockId("")
    }, [selectedDistrictId])
    return (
        <>
            <div className="">
                <Form.Select
                    value={selectedBlockId}
                    onChange={handleChange}
                    className={`me-2 ${className}`}
                    style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                    required={required}
                    disabled={disabled || !selectedDistrictId}

                > <option value="">All Block</option>
                    {blockList.map((item) => {
                        return (
                            <>

                                <option key={item.id} value={item.id}>{item?.label}</option>
                            </>
                        )
                    })}


                </Form.Select>
            </div>
        </>
    )
}

export default BlockFilter
